import {createReducer} from '@reduxjs/toolkit';
import {
  clearCompareSubjects,
  setCompareMethod,
  setCompareSubject,
  setCompareSubjects,
  swapCompareSubjects,
} from '@src/actions/compare.js';
import {executeSearch} from '@src/actions/search.js';
import {setMode} from '@src/actions/ui.ts';
import {COMPARE_METHODS, UI_MODES} from '@src/constants';

export const initialState = {
  method: COMPARE_METHODS.SLIDER,
  subjects: {
    0: null,
    1: null,
  },
};

const compare = createReducer(initialState, builder => {
  builder.addCase(setCompareSubject, (state, {payload}) => {
    state.subjects[payload.index] = payload.subject;
  });

  builder.addCase(setCompareSubjects, (state, {payload}) => {
    state.subjects = payload;
  });

  builder.addCase(setCompareMethod, (state, {payload}) => {
    state.method = payload;
  });

  builder.addCase(swapCompareSubjects, state => {
    const subjects = {
      0: state.subjects[1],
      1: state.subjects[0],
    };

    state.subjects = subjects;
  });

  builder.addCase(clearCompareSubjects, state => {
    state.subjects = initialState.subjects;
  });

  builder.addCase(setMode, (state, {payload: mode}) => {
    if (mode !== UI_MODES.COMPARE) {
      return initialState;
    }
    return state;
  });

  builder.addCase(executeSearch, state => {
    state.subjects = initialState.subjects;
  });
});

export default compare;
